import type { EstadoValidacion } from '../../api/cargas'

const CONFIG: Record<EstadoValidacion, { label: string; classes: string }> = {
  VALIDA:             { label: 'Válida',     classes: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300' },
  OUTLIER:            { label: 'Outlier',    classes: 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300' },
  PENDIENTE_REVISION: { label: 'Pendiente',  classes: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300' },
  RECHAZADA:          { label: 'Rechazada',  classes: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300' },
}

interface BadgeProps {
  estado: EstadoValidacion
  className?: string
}

export function Badge({ estado, className = '' }: BadgeProps) {
  const cfg = CONFIG[estado]
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${cfg.classes} ${className}`}>
      {cfg.label}
    </span>
  )
}

interface GenericBadgeProps {
  label: string
  variant?: 'default' | 'success' | 'danger' | 'warning' | 'info'
  className?: string
}

const VARIANT_CLASSES: Record<NonNullable<GenericBadgeProps['variant']>, string> = {
  default: 'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-300',
  success: 'bg-emerald-100 text-emerald-800',
  danger:  'bg-red-100 text-red-800',
  warning: 'bg-yellow-100 text-yellow-800',
  info:    'bg-blue-100 text-blue-800',
}

export function GenericBadge({ label, variant = 'default', className = '' }: GenericBadgeProps) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${VARIANT_CLASSES[variant]} ${className}`}>
      {label}
    </span>
  )
}
